import { Row, RenderConfig, TextInput } from 'commons-ui';
import { FORM_FIELD_KEYS, FORM_FIELD_LABELS, PLACEHOLDERS } from './constants';

export const DEFAULT_CONFIG = {
	pageDetails: {
		pageNo: 1,
		pageSize: 20
	}
};

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.DESCRIPTION]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.DESCRIPTION)
		.setLabel(FORM_FIELD_LABELS.DESCRIPTION)
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true },
			isHidden: { create: false },
			required: true,
			placeholder: PLACEHOLDERS.DESCRIPTION
		})
};

export const FORM_LAYOUT_CONFIG = [new Row(FORM_FIELD_KEYS.DESCRIPTION)];

export const getStatusColor = (status: string, colorMap: Record<string, string>): string => {
	return colorMap[status] || colorMap.DEFAULT;
};
